import { render, staticRenderFns } from "./CampaignHeader.vue?vue&type=template&id=a32c6fba&"
import script from "./CampaignHeader.vue?vue&type=script&lang=js&"
export * from "./CampaignHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports